
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component
export default class PelletsChartTooltip extends Vue {
  @Prop({ required: true }) tooltipId!: string;
  @Prop({ required: true }) colorId!: (index: number) => string;
  @Prop({ required: true }) valueId!: (index: number) => string;
  @Prop({ default: 2 }) itemCount!: number;
}
